import React, { Component } from 'react';
import Item from '../item';
import { NoContent } from '../../ui';

export default class extends Component {
    render() {
        const { data, onItemClick, onItemDoubleClick } = this.props;

        return (
            <div className="group-list">
                {
                    data.map((item, index)=>{
                        return <Item data={item} onClick={onItemClick} onDoubleClick={onItemDoubleClick}/>
                    })
                }
                { data.length ? null: <NoContent text="暂无讨论组"/> }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/group/list/index.js